export class EnumHelper {
	public static GetDescription(e: any, id: number): string {
		return e[e[id] + 'Description'];
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/helpers/enum-helper.ts